export default __webpack_public_path__ + "static/media/img_gas_phase_en_03.c738abe6.png";